import { gql } from "@apollo/client";

const GET_PROMO_TYPES = gql`
  query PromoTypes {
    promoTypes {
      items {
        promoTypeId
        promoTypeName
        promoTypeCode
        promoTypeKey
      }
      count
    }
  }
`;

export default GET_PROMO_TYPES;
